export namespace AssetTranslations {
  export const common = {
    asset: 'asset',
    assetExportConfiguration: 'assetExportConfiguration',
  } as const;

  export const error = {
    assetsUnableToLoadError: 'assetsUnableToLoadError',
    assetExportConfigurationsUnableToLoadError: 'assetExportConfigurationsUnableToLoadError',
  } as const;

  export const exportConfigurations = {
    assetExportConfigurationDeleteConfirmationText: 'assetExportConfigurationDeleteConfirmationText',
  } as const;
}
